import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { createVideo } from "../../../../services/video";
import { Media } from "../../../../interfaces/media";
import { useState } from "react";
import Uploader from "../../../general/uploader";
import { createProgramMedia } from "../../../../services/program";

interface ProgramMediaNewProps {
    program_id: number;
    folder_id: number | null;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function ProgramMediaNew(props: ProgramMediaNewProps) {
    const [media, setMedia] = useState<Media[]>([]);

    const handleSave = (event: any) => {
        event.preventDefault();

        if (media.length == 0) {
            alert(t("You must upload one video, image or document"));
            return false;
        }

        const body: any = {
            program_id: props.program_id,
            name: event.target.name.value,
            description: event.target.description.value,
            media: media.length > 0 ? media[0].id : 0
        }

        if (props.folder_id !== null) {
            body.folder_id = props.folder_id;
        }

        createProgramMedia(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleMediaEventUpload = (media: Media[]) => {
        if (media.length > 1) {
            alert(t("Only one document can be uploaded. Delete the current document to upload a different one."));
        } else {
            const newMedia = media.map((m: Media) => { return m; });
            setMedia(newMedia);
        }
    }
    
    return (
        <Modal className="document-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("New media") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                            <Form.Control type="text" name="name" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="description">
                            <Form.Label>{ t("description") }</Form.Label>
                            <Form.Control name="description" as="textarea" />
                        </Form.Group>
                        <Form.Group className="mb-3 media-field" controlId="media">
                            <Uploader title={ t("Upload video, file or document") }
                                media={ media } save={ handleMediaEventUpload } />
                        </Form.Group>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}